module.exports = __webpack_public_path__ + "static/fonts/ac-icons.98ecadd2.svg";